import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from "react";
import { useRegisterCallbacks } from "./ConversationContext.js";
const ConversationStatusContext = createContext(null);
/**
 * Reads from `ConversationContext` and registers `onStatusChange` + `onError`
 * callbacks. Manages its own `status`/`message` state and provides it through
 * `ConversationStatusContext`. Must be rendered inside a `ConversationProvider`.
 */
export function ConversationStatusProvider({ children, }) {
    const [status, setStatus] = useState("disconnected");
    const [message, setMessage] = useState(undefined);
    useRegisterCallbacks({
        onStatusChange({ status: newStatus }) {
            if (newStatus === "disconnecting") {
                // Transient state — keep current status
                return;
            }
            setStatus(newStatus);
            // Clear error message when transitioning to a non-error state
            setMessage(undefined);
        },
        onError(errorMessage) {
            setStatus("error");
            setMessage(errorMessage);
        },
    });
    const value = useMemo(() => ({ status, message }), [status, message]);
    return (_jsx(ConversationStatusContext.Provider, { value: value, children: children }));
}
/**
 * Returns the current conversation status and any error message.
 * Re-renders when the connection status or error message changes.
 *
 * Must be used within a `ConversationProvider`.
 */
export function useConversationStatus() {
    const ctx = useContext(ConversationStatusContext);
    if (!ctx) {
        throw new Error("useConversationStatus must be used within a ConversationProvider");
    }
    return ctx;
}
//# sourceMappingURL=ConversationStatus.js.map